import { PlainText } from './PlainText'
import { ItalicText } from './ItalicText'
import { StrikeText } from './StrikeText'

export const BoldText = ({ contents }) => (
    <strong>
        {contents.map((content, index) => {
            switch (content.type) {
                case 'PLAIN_TEXT':
                    return <PlainText key={index} contents={content.value} />

                case 'STRIKE':
                    return <StrikeText key={index} contents={content.value} />

                case 'ITALIC':
                    return <ItalicText key={index} contents={content.value} />

                default:
                    return null
            }
        })}
    </strong>
)
